import { render, staticRenderFns } from "./singe.vue?vue&type=template&id=7fd80ee1&scoped=true&"
import script from "./singe.vue?vue&type=script&lang=js&"
export * from "./singe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd80ee1",
  null
  
)

export default component.exports